/* eslint-disable @typescript-eslint/no-explicit-any */
import clsx from 'clsx';

import { getTypographyClassaname } from '@components/typography';

import { cn } from '@src/lib/utils';

import { TextReveal } from '@/components/ui/scroll-reveal';

export default function TextRevealSection({
  text,
  offset = 'h-[150vh] lg:h-[200vh]',
}: {
  text: string;
  offset?: string;
}) {
  return (
    <div className="w-full md:px-0 relative">
      <div className="sticky top-[25vh] lg:top-0 h-[75vh] lg:h-screen pointer-events-none">
        <div
          id="dotBG"
          className={cn(
            'absolute inset-0 z-0',
            '[background-size:20px_20px]',
            '[background-image:radial-gradient(#d4d4d4_1px,transparent_1px)]',
            'dark:[background-image:radial-gradient(#404040_1px,transparent_1px)]'
          )}
        ></div>
        <div className="absolute inset-0 flex items-center justify-center bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] dark:bg-black"></div>
      </div>

      <TextReveal body={text} className={`relative w-full ${offset} -mt-[75vh] -lg:mt-[100vh]`}>
        {(tokens: string[]) => (
          <div
            className={cn(
              'sticky left-0 top-0 flex h-1/2 items-center text-3xl font-medium leading-tight text-black',
              getTypographyClassaname('titlesmall', 'center')
            )}
          >
            <div>
              {(() => {
                const lnBreakIndex = tokens.findIndex((item) => item === '\n');

                const preLnBreak = tokens.slice(0, lnBreakIndex === -1 ? tokens.length : lnBreakIndex);
                const postLnBreak = lnBreakIndex === -1 ? [] : tokens.slice(lnBreakIndex, tokens.length);

                const cumulativeIndex = preLnBreak.length;
                const pre = preLnBreak.map((token, index) => (
                  <TextReveal.Token key={index} index={index}>
                    {(isActive: boolean) => (
                      <span
                        className={clsx(
                          {
                            'opacity-10': !isActive,
                          },
                          'transition'
                        )}
                      >
                        {token}
                      </span>
                    )}
                  </TextReveal.Token>
                ));

                let pos: any = [];
                if (postLnBreak.length > 0)
                  pos = postLnBreak.map((token, index) => (
                    <TextReveal.Token key={`pos-${index}`} index={index + cumulativeIndex}>
                      {(isActive: boolean) => (
                        <span
                          className={clsx(
                            {
                              'opacity-10': !isActive,
                            },
                            'shrink-0',
                            'whitespace-pre-line',
                            'transition',
                            getTypographyClassaname('subtitle', 'center')
                          )}
                        >
                          {token}
                        </span>
                      )}
                    </TextReveal.Token>
                  ));

                if (pos.length > 0)
                  return [
                    ...pre,
                    <div style={{ lineHeight: 0 }} key={'mx'}>
                      {...pos}
                    </div>,
                  ];
                return pre;
              })()}
            </div>
          </div>
        )}
      </TextReveal>
    </div>
  );
}
